import {
  CheckCircledIcon,
  PieChartIcon,
  ValueNoneIcon,
} from "@radix-ui/react-icons";
import { LocaleTranslationState } from "../context/templates-editor-locale-context";

export function LocaleStateIcon({ state }: { state: LocaleTranslationState }) {
  const Comp = {
    empty: <ValueNoneIcon className="size-4 text-muted-foreground/80" />,
    full: <CheckCircledIcon className="size-4 text-green-300" />,
    partial: <PieChartIcon className="size-4 text-orange-300" />,
  }[state];

  return Comp;
}
